<template>
    <!-- Aba de Cálculos -->
    <div class="tab-pane fade show active" id="shellCilindInternalPressCalculator">

        <!-- BOTÃO DESENHO DE APOIO -->
        <h5 class="text mt-5 text-primary">
            <b>Desenho de apoio</b>
        </h5>

        <!-- VER DESENHO -->
        <div class="col-2">
            <button
            type="button"
            class="btn btn-secundario"
            @click="mostrarDesenho()"
            >
            Mostrar desenho
            </button>
        </div>

        <!-- POPUP COM O DESENHO -->
        <DesenhoApoio
        v-model="showDrawing"
        :tipo="1"
        />

        <h5 class="text mt-5 text-primary">
            <b>Cylindrical Shell Under Internal Pressure According To ASME VIII Div.1 (UG - 27)</b>
        </h5>
        
        <form ref="formCalculo" @submit.prevent="calculos">

            <div class="table-responsive material-table">

                <table class="table mt-5">

                    <thead>
                        <tr>
                            <th scope="col">DESIGN DATA</th>
                            <th scope="col"></th>
                            <th scope="col">VALUE</th>
                            <th scope="col">UNITS</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <th scope="row">
                                <b>Material Specification <br>(ASME II part D)</b>
                                <InterrogacaoHover text="Especificação do material conforme ASME Section II Part D. Define propriedades mecânicas como tensão admissível (allowable stress), limites de temperatura e características necessárias para os cálculos de projeto do vaso de pressão." />
                            </th>
                            <td>
                                <!-- Container com posição relativa para conter a lista -->
                                <div class="position-relative">
                                    <!-- BUSCA -->
                                    <div class="position-relative">
                                        <input
                                        type="search"
                                        class="form-control ps-5 input"
                                        placeholder="Buscar material"
                                        v-model="materialSearch"

                                        @focus="abrirListaMaterial"
                                        @click="abrirListaMaterial"
                                        @input="handleInput"
                                        @blur="fecharListaMaterial"
                                        required
                                        />

                                        <!-- ÍCONE LUPA -->
                                        <span
                                            class="position-absolute start-0 top-50 translate-middle-y ps-3"
                                        >
                                            <img src="@/views/img/search-icon.svg" width="16" />
                                        </span>
                                    </div>

                                    <!-- LISTA DE RESULTADOS - Agora dentro do container position-relative -->
                                    <ul
                                        v-if="mostrarListaMaterial && materiaisFiltrados.length"
                                        class="material-options list-group position-absolute w-100 mt-1"
                                    >
                                        <li
                                            class="material-option list-group-item list-group-item-action"
                                            v-for="(material, index) in materiaisFiltrados"
                                            :key="material.materialSpecification + index"
                                            @mousedown.prevent="selecionarMaterial(material)"
                                        >
                                            <b>{{ [material.materialSpecification, material.classConditionTemper].filter(Boolean).join(" ") }}</b>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Nominal Composition</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.nominalComposition }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Product Form</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.productForm }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Alloy Designation/UNS No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.alloyDesignation }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Class/Condition/Temper</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.classConditionTemper }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">P-No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.pNo }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Group No.</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.groupNo }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Min. Tensile Strength</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.minTensileStrength }}
                                </h6>
                            </td>
                            <td> </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Min. Yield Strength</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.minYieldStrength }}
                                </h6>
                            </td>
                            <td> </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">VIII-1—Applic, and Max, Temp, Limit (°C)</th>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.viiiApplicAndMaxTemLimit }}
                                </h6>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Design Temperature</th>
                            <td>DT</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.designTemperature }}
                                </h6>
                            </td>
                            <td>°C</td>
                        </tr>

                        <tr>
                            <th scope="row"><b>Inside Diameter</b>
                                <InterrogacaoHover text="Di é o diâmetro interno do vaso. Usado no cálculo da espessura conforme ASME UG-27." />
                            </th>
                            <td><b>Di</b></td>
                            <td>
                                <input type="number" step="any" class="form-control input" v-model="shellCilindInternalPressCalculator.insideDiameter" required/>
                            </td>
                            <td><b>mm</b></td>
                        </tr>

                        <tr>
                            <th scope="row"><b>Liquid Column</b>
                                <InterrogacaoHover text="Altura da coluna de fluido usada para calcular pressão hidrostática adicional." />
                            </th>
                            <td><b>H</b></td>
                            <td>
                                <input type="number" step="any" class="form-control" v-model="shellCilindInternalPressCalculator.liquidColumn" 
                                :disabled="posicao === 'Cima' || designDataPosition === 'Horizontal'" required/>
                            </td>
                            <td><b>m</b></td>
                        </tr>
                        <tr>
                            <th scope="row"><b>Shell Length</b>
                                <InterrogacaoHover text="Comprimento total do casco cilíndrico, medido ao longo do eixo longitudinal do vaso. É utilizado para definir a extensão do casco e pode ser considerado em verificações de projeto e volume." />
                            </th>
                            <td><b>L</b></td>
                            <td>
                                <input type="number" step="any" class="form-control input" v-model="shellCilindInternalPressCalculator.shellLength" required />
                            </td>
                            <td><b>mm</b></td>
                        </tr>
                        <tr>
                            <th scope="row">Fluid Density</th>
                            <td>-</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.density }}
                                </h6>
                            </td>
                            <td><b>kg/m³</b></td>
                        </tr>
                        <tr>
                            <th scope="row">Design Pressure on the Top of the Vessel</th>
                            <td>Pint</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.designPressureTop }} 
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Design Pressure</th>
                            <td>P</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.designPressure }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Admissible Stress @ Design Temperature</th>
                            <td>Sh</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.admissibleStressDesignTemp }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Admissible Stress @ Room Temperature</th>
                            <td>Sc</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.admissibleStressRoomTemp }}
                                </h6>
                            </td>
                            <td>MPa</td>
                        </tr>
                        <tr>
                            <th scope="row">Inside Radius</th>
                            <td>Ri</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.insideRadius }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Inside Radius Corroded</th>
                            <td>Ric</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.insideRadiusCorroded }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Corrosion Allowance</th>
                            <td>CA</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.corrosionAllowance }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row">Nominal Thickness minus Corrosion Allowance</th>
                            <td>CA</td>
                            <td>
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.nominalThicknessMinusCorrosionAloowance }}
                                </h6>
                            </td>
                            <td>mm</td>
                        </tr>
                        <tr>
                            <th scope="row"><b>Welded Joint Efficiency</b>
                                <InterrogacaoHover text="Eficiência da junta soldada (E) conforme ASME VIII Div.1 (UW-12). Depende do tipo de junta e do grau de inspeção (RT). Valores típicos variam de 0.6 a 1.0 e influenciam diretamente o cálculo da espessura mínima requerida." />
                            </th>
                            <td>-</td>
                            <td>
                                <select class="form-select input" v-model="shellCilindInternalPressCalculator.weldedJointEfficiency" required>
                                    <option value="" selected>Selecione</option>
                                    <option value="1.00">1.00</option>
                                    <option value="0.90">0.90</option>
                                    <option value="0.85">0.85</option>
                                    <option value="0.80">0.80</option>
                                    <option value="0.70">0.70</option>
                                    <option value="0.65">0.65</option>
                                    <option value="0.60">0.60</option>                                    
                                </select>
                            </td>
                            <td>--</td>
                        </tr>
                        <tr>
                            <th scope="row"><b>Nominal Thickness</b>
                                <InterrogacaoHover text="Espessura nominal do casco (tn). Valor adotado comercialmente que deve atender ou exceder a espessura mínima requerida calculada (t), incluindo margem de corrosão (CA), conforme ASME VIII Div.1." />
                            </th>
                            <td>-</td>
                            <td>
                                <select class="form-select input" v-model="shellCilindInternalPressCalculator.nominalThickness" required>
                                    <option value="" selected>Selecione</option>
                                    <option v-for="opcao in nominalThicknessOptions" :key="opcao" :value="opcao">
                                        {{ opcao }}
                                    </option>
                                </select>
                            </td>
                            <td>--</td>
                            
                        </tr>

                        <!-- Scroll para ver resultados -->
                        <div class="mb-5" id="calculation-results"></div>

                    </tbody>

                </table>
            </div>

            <tr></tr>
            <!-- Calculation results -->
            <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3">
                <h4 class="mb-0">
                    <b>Calculation Results:</b>
                </h4>

                <span
                    v-if="shellCilindInternalPressCalculator.validNominalThickness"
                    class="badge bg-success fs-6 px-3 py-2"
                >
                    <b>✔ Nominal Thickness Valid</b>
                </span>

                <span
                    v-else
                    class="badge bg-danger fs-6 px-3 py-2"
                >
                    <b>✖ Nominal Thickness Not Valid</b>
                </span>
            </div>

            <!-- Drawing -->
            <div class="form-group calculator-drawing mt-3 row">
                <div class="calculator-drawing-title">Drawing</div>
                <div class="col d-flex justify-content-center">
                    <div class="calculator-drawing-frame">
                        <img src="../img/calculator-shell-cilind-internal-press/drawing-shell-cilind-internal-press.png" alt="Image of Drawing" class="calculator-drawing-image">
                    </div>
                </div>
            </div>

            <div class="table-responsive">

                <table class="table mt-5">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 40%; text-align: left;">DESIGN DATA</th>
                            <th scope="col" style="width: 20%; text-align: center;"></th>
                            <th scope="col" style="width: 20%; text-align: center;">VALUE</th>
                            <th scope="col" style="width: 20%; text-align: center;">UNITS</th>
                        </tr>
                    </thead>

                    <tbody>
                        
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Design Thickness
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>LONGITUDINAL JOINTS </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-shell-cilind-internal-press/design-thickness.png" width="300px" alt="Formula for Thickness" class="img-formulas">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">t</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.designThickness }}
                                </h6>
                            </td>
                            
                            <td style="text-align: center;">mm</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Working Maximum Allowable Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>LONGITUDINAL JOINTS </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-shell-cilind-internal-press/working-maximum-allowable-pressure.png" width="300px" alt="Formula for MAWPc" class="img-formulas">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">MAWPc</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.workingMaximumAllowablePressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Hydrostatic Test Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>HIDROSTATIC TEST PRESSURE </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-shell-cilind-internal-press/hidrostatic-test-pressure.png" width="300px" alt="Formula for HTP" class="img-formulas">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">HTP</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.hidrostaticTestPressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                        <tr>
                            <th scope="row" style="text-align: left;">
                                Pneumatic Test Pressure
                                <div class="form-group mt-3 row">
                                    <label class="mt-1"><b>PNEUMATIC TEST PRESSURE </b></label>
                                    <div class="col d-flex">
                                        <img src="../img/calculator-shell-cilind-internal-press//pneumatic-test-pressure.png" width="300px" alt="Formula for PTP" class="img-formulas">
                                    </div>
                                </div>
                            </th>
                            <td style="text-align: center;">PTP</td>
                            <td style="text-align: center;">
                                <h6 class="text my-auto">
                                    {{ shellCilindInternalPressCalculator.pneumaticTestPressure }}
                                </h6>
                            </td>
                            <td style="text-align: center;">MPa</td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </form>
    </div>

</template>

<script>
import DatabaseThickPlateASTM_A20 from "@/models/database/DatabaseThickPlateASTM_A20.js";
import arrayMateriaisASMEII from "../../../../backend/src/database/asmeii/arrayMateriaisASMEII.js";
import InterrogacaoHover from "../../componentesTelas/InterrogacaoHover.vue";
import DesenhoApoio from "../../componentesTelas/DesenhoApoio.vue";

export default {
    name: "ShellCilindInternalPressCalculatorComponent",
    props: {
        shellCilindInternalPressCalculatorProps: {
            type: Object,
            required: true,
        },
        designData: {
            type: Object,
            required: true,
        },
    },
    components: {
        InterrogacaoHover,
        DesenhoApoio
    },
    data() {
        return {
            shellCilindInternalPressCalculator: this.shellCilindInternalPressCalculatorProps,
            nominalThicknessOptions: [],
            materialSpecificationOptions: [], // Armazena todos os materiais

            // BUSCA MATERIAL
            materialSearch: "",
            mostrarListaMaterial: false,
            debounceTimeout: null,

            // EXIBIR DESENHO DE APOIO
            showDrawing: false,
        };
    },
    mounted() {
        
    },

    watch: {
        // Seta o valor do material no campo de busca
        'shellCilindInternalPressCalculator.materialSpecification': {
            immediate: true,
            deep: true,
            handler(material) {
            if (
                material &&
                typeof material === 'object' &&
                material.materialSpecification
            ) {
                this.materialSearch = material.materialSpecification;
            }
            }
        }
    },

    computed: {
        // Verifica a posição do designData
        designDataPosition() {
            if (this.designData?.position) {
                return this.designData.position;
            }
            return null;
        },

        // Lista de materiais filtrados
        materiaisFiltrados() {
            const termo = this.materialSearch.toLowerCase().trim();
            
            let resultados;
            
            if (!termo) {
                resultados = this.materialSpecificationOptions;
            } else {
                resultados = this.materialSpecificationOptions.filter(mat => {
                    const materialName = mat.materialSpecification?.toLowerCase() || '';
                    return materialName.includes(termo);
                });
            }
            
            // ORDENAÇÃO GARANTIDA - por materialSpecification em ordem crescente
            const resultadosOrdenados = [...resultados].sort((a, b) => {
                const nameA = (a.materialSpecification || '').toString();
                const nameB = (b.materialSpecification || '').toString();
                
                // Extrai números dos nomes para ordenação numérica apropriada
                const numMatchA = nameA.match(/\d+/g);
                const numMatchB = nameB.match(/\d+/g);
                
                // Se ambos têm números, ordena numericamente
                if (numMatchA && numMatchB) {
                    // Compara o primeiro número encontrado
                    const numA = parseInt(numMatchA[0]);
                    const numB = parseInt(numMatchB[0]);
                    
                    if (numA !== numB) {
                        return numA - numB;
                    }
                }
                
                // Fallback para ordenação alfabética com localeCompare
                return nameA.localeCompare(nameB, undefined, { 
                    numeric: true,
                    sensitivity: 'base'
                });
            });
            
            return resultadosOrdenados;
        }
    },
    created() {
        const database1 = new DatabaseThickPlateASTM_A20();
        this.nominalThicknessOptions = database1.nominalThickness;

        // Carrega e ORDENA os materiais em ordem crescente
        this.carregarMateriaisOrdenados();
    },

    methods: {

        // CONTROLES DO DESENHO DE APOIO
        mostrarDesenho() {
            if(this.showDrawing === false){
                this.showDrawing = true;
            }
            else{
                this.showDrawing = false;
            }            
        },

        // CONTROLE DA IMAGEM FLUTUANTE
        startDrag(e) {
            this.dragging = true
            this.offsetX = e.clientX - this.posX
            this.offsetY = e.clientY - this.posY

            document.addEventListener('mousemove', this.onDrag)
            document.addEventListener('mouseup', this.stopDrag)
        },

        onDrag(e) {
            if (!this.dragging) return
            this.posX = e.clientX - this.offsetX
            this.posY = e.clientY - this.offsetY
        },

        stopDrag() {
            this.dragging = false
            document.removeEventListener('mousemove', this.onDrag)
            document.removeEventListener('mouseup', this.stopDrag)
        },

        abrirListaMaterial() {
            this.mostrarListaMaterial = true;
        },

        fecharListaMaterial() {
            setTimeout(() => {
            this.mostrarListaMaterial = false;
            }, 150);
        },

        // Método para carregar e ordenar materiais
        carregarMateriaisOrdenados() {
            if (Array.isArray(arrayMateriaisASMEII)) {
                // Ordena os materiais pelo materialSpecification em ordem crescente
                this.materialSpecificationOptions = arrayMateriaisASMEII
                    .slice() // Cria uma cópia
                    .sort((a, b) => {
                        const materialA = a.materialSpecification || '';
                        const materialB = b.materialSpecification || '';
                        
                        // Extrai números para ordenação numérica
                        const numMatchA = materialA.match(/\d+/g);
                        const numMatchB = materialB.match(/\d+/g);
                        
                        if (numMatchA && numMatchB) {
                            const numA = parseInt(numMatchA[0]);
                            const numB = parseInt(numMatchB[0]);
                            
                            if (numA !== numB) {
                                return numA - numB;
                            }
                        }
                        
                        // Ordenação alfabética para strings sem números ou números iguais
                        return materialA.localeCompare(materialB, undefined, { 
                            numeric: true,
                            sensitivity: 'base'
                        });
                    });

                } else {
                    console.error('arrayMateriaisASMEII não é um array válido');
                    this.materialSpecificationOptions = [];
                }
            },

        // Método para lidar com input enquanto digita
        handleInput() {
            // Limpa timeout anterior
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            
            // Abre a lista imediatamente quando começa a digitar
            if (this.materialSearch.trim() !== '' && !this.mostrarListaMaterial) {
                this.mostrarListaMaterial = true;
            }
            
            // Se apagou tudo, fecha a lista
            if (this.materialSearch.trim() === '') {
                this.mostrarListaMaterial = false;
                return;
            }
            
            // Configura novo timeout para garantir que a lista fique aberta
            this.debounceTimeout = setTimeout(() => {
                if (this.materialSearch.trim() !== '') {
                    this.mostrarListaMaterial = true;
                }
            }, 100);
        },

        selecionarMaterial(material) {
            this.shellCilindInternalPressCalculator.materialSpecification = material;
            this.materialSearch = material.materialSpecification;
            this.mostrarListaMaterial = false;

            this.atualizarCamposMaterial();
            this.calculos();
        },

        buscarCampoAdmissibleStressDatabaseASMEII(materialSpecification, chaveGrausCelsiusBuscada) {

            if (!materialSpecification || !materialSpecification.rangeDesignTemperatureCelsius) {
                console.warn("Material ou rangeDesignTemperatureCelsius não encontrado");
                return null;
            }

            const tabela = materialSpecification.rangeDesignTemperatureCelsius;

            // 🔹 normaliza a chave buscada
            let chaveNormalizada = chaveGrausCelsiusBuscada;

            if (typeof chaveNormalizada === "string" && chaveNormalizada.includes(",")) {
                chaveNormalizada = chaveNormalizada.replace(",", ".");
            }

            const chaveBuscada = parseFloat(chaveNormalizada);


            // 🔹 se existir valor exato
            if (tabela[chaveNormalizada] !== undefined) {
                return parseFloat(tabela[chaveNormalizada]);
            }

            // 🔹 preparar temperaturas numéricas
            const temperaturasStr = Object.keys(tabela);
            const temperaturasNum = temperaturasStr
                .map(t => parseFloat(t.replace(",", ".")))
                .sort((a, b) => a - b);

            if (chaveBuscada < temperaturasNum[0] || chaveBuscada > temperaturasNum[temperaturasNum.length - 1]) {
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const temperaturaExata = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === chaveBuscada
            );

            if (temperaturaExata !== undefined) {
                return parseFloat(tabela[temperaturaExata]);
            }

            // 🔹 encontrar anterior e posterior
            const indicePosterior = temperaturasNum.findIndex(t => t > chaveBuscada);
            const indiceAnterior = indicePosterior > 0 ? indicePosterior - 1 : -1;

            if (indiceAnterior < 0 || indicePosterior === -1) {
                console.warn("Temperatura fora do range do material");
                this.$emit("temperatura-fora-faixa", {
                    temperatura: chaveBuscada,
                    minimo: temperaturasNum[0],
                    maximo: temperaturasNum[temperaturasNum.length - 1],
                });
                return null;
            }

            const tempAnterior = temperaturasNum[indiceAnterior];
            const tempPosterior = temperaturasNum[indicePosterior];

            const chaveAnteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempAnterior
            );
            const chavePosteriorStr = temperaturasStr.find(
                t => parseFloat(t.replace(",", ".")) === tempPosterior
            );

            const valorAnterior = parseFloat(tabela[chaveAnteriorStr]);
            const valorPosterior = parseFloat(tabela[chavePosteriorStr]);

            // 🔹 interpolação linear (mesma lógica do backend)
            const fator =
                (chaveBuscada - tempAnterior) /
                (tempPosterior - tempAnterior);

            const interpolado =
                valorAnterior + (valorPosterior - valorAnterior) * fator;

            return interpolado.toFixed(2);

            // return Number(interpolado.toFixed(3));
        },

        atualizarCamposMaterial() {
            const materialSelecionado = this.shellCilindInternalPressCalculator.materialSpecification;
            if (materialSelecionado) {
                this.shellCilindInternalPressCalculator.nominalComposition = materialSelecionado.nominalComposition || '';
                this.shellCilindInternalPressCalculator.productForm = materialSelecionado.productForm || '';
                this.shellCilindInternalPressCalculator.alloyDesignation = materialSelecionado.alloyDesignation || '';
                this.shellCilindInternalPressCalculator.classConditionTemper = materialSelecionado.classConditionTemper || '';
                this.shellCilindInternalPressCalculator.pNo = materialSelecionado.pNo || '';
                this.shellCilindInternalPressCalculator.groupNo = materialSelecionado.groupNo || '';
                this.shellCilindInternalPressCalculator.minTensileStrength = materialSelecionado.minTensileStrength || '';
                this.shellCilindInternalPressCalculator.minYieldStrength = materialSelecionado.minYieldStrength || '';
                this.shellCilindInternalPressCalculator.viiiApplicAndMaxTemLimit = materialSelecionado.viiiApplicAndMaxTemLimit || '';
                // this.calculos();
            } else {
                console.warn("Material não encontrado no DatabaseASMEII");
            }
            // this.calculos();
        },

        async calculos(){
            if (this.$refs.formCalculo && !this.$refs.formCalculo.reportValidity()) {
                return;
            }

            // -- PARTE 1 - DESIGN DATA -- //

            // RANGE DESIGN TEMPERATURE
            if(this.shellCilindInternalPressCalculator.viiiApplicAndMaxTemLimit === "NP"){
                this.shellCilindInternalPressCalculator.designTemperature = this.shellCilindInternalPressCalculator.viiiApplicAndMaxTemLimit;
            } 
            else if(this.converterParaFloat(this.shellCilindInternalPressCalculator.viiiApplicAndMaxTemLimit) >= this.designData.designTemperature){
                this.shellCilindInternalPressCalculator.designTemperature = this.designData.designTemperature
            } 
            else if(this.converterParaFloat(this.shellCilindInternalPressCalculator.viiiApplicAndMaxTemLimit) <= this.designData.designTemperature){
                this.shellCilindInternalPressCalculator.designTemperature = "TEMPERATURE OVER MATERIAL LIMIT";
            }

            // FLUID DENSITY
            this.shellCilindInternalPressCalculator.fluidDensity = this.designData.density;

            // DESIGN PRESSURE ON THE TOP OF THE VESSEL
            this.shellCilindInternalPressCalculator.designPressureTop = this.designData.designInternalPressure;

            // DESIGN PRESSURE
            this.shellCilindInternalPressCalculator.designPressure = (((this.shellCilindInternalPressCalculator.liquidColumn * this.shellCilindInternalPressCalculator.fluidDensity * 9.81) / 1000000) + this.shellCilindInternalPressCalculator.designPressureTop).toFixed(2);

            // ADMISSIBLE STRESS @ DESIGN TEMPERATURE
            this.shellCilindInternalPressCalculator.admissibleStressDesignTemp = "...";

            const chaveGrausCelsiusBuscada = this.designData.designTemperature;

            try {
                const resultado = await this.buscarCampoAdmissibleStressDatabaseASMEII(
                    this.shellCilindInternalPressCalculator.materialSpecification,
                    chaveGrausCelsiusBuscada
                );
                this.shellCilindInternalPressCalculator.admissibleStressDesignTemp = resultado;

            } catch (error) {
                console.error("Erro ao buscar admissibleStressDesignTemp:", error);
            }

            // ADMISSIBLE STRESS @ ROOM TEMPERATURE 
            try {
                const resultado = await this.buscarCampoAdmissibleStressDatabaseASMEII(
                    this.shellCilindInternalPressCalculator.materialSpecification,
                    "37,78"
                );
                this.shellCilindInternalPressCalculator.admissibleStressRoomTemp = resultado;
            } catch (error) {
                console.error("Erro ao buscar admissibleStressRoomTemp:", error);
            }

            // INSIDE RADIUS
            this.shellCilindInternalPressCalculator.insideRadius = this.shellCilindInternalPressCalculator.insideDiameter / 2;

            // CORROSION ALLOWANCE
            this.shellCilindInternalPressCalculator.corrosionAllowance = this.designData.corrosionAllowance;

            // INSIDE RADIUS CORRODED
            this.shellCilindInternalPressCalculator.insideRadiusCorroded = (this.shellCilindInternalPressCalculator.insideDiameter / 2) + this.shellCilindInternalPressCalculator.corrosionAllowance;

            // NOMINAL THICKNESS minus Corrosion Allowance
            this.shellCilindInternalPressCalculator.nominalThicknessMinusCorrosionAloowance = this.shellCilindInternalPressCalculator.nominalThickness - this.shellCilindInternalPressCalculator.corrosionAllowance;

            // VALID OU INVALID NOMINAL THICKNESS
            if(this.shellCilindInternalPressCalculator.nominalThickness < this.shellCilindInternalPressCalculator.designThickness){
                this.shellCilindInternalPressCalculator.validNominalThickness = false;
                }
            else {
                this.shellCilindInternalPressCalculator.validNominalThickness = true;
            }

            // -- PARTE 2 - DESIGN VALIDATION -- //

            // DESIGN THICKNESS
            if(this.shellCilindInternalPressCalculator.weldedJointEfficiency === "NA"){
                this.shellCilindInternalPressCalculator.weldedJointEfficiency = 1.0;
            }
            if(this.shellCilindInternalPressCalculator.designPressure < 0.384 * this.shellCilindInternalPressCalculator.admissibleStressDesignTemp * this.shellCilindInternalPressCalculator.weldedJointEfficiency) {
                let resultado = ((this.shellCilindInternalPressCalculator.designPressure * this.shellCilindInternalPressCalculator.insideRadiusCorroded) / ((this.shellCilindInternalPressCalculator.admissibleStressDesignTemp * this.shellCilindInternalPressCalculator.weldedJointEfficiency) - (0.6 * this.shellCilindInternalPressCalculator.designPressure))) + this.shellCilindInternalPressCalculator.corrosionAllowance;
                this.shellCilindInternalPressCalculator.designThickness = resultado.toFixed(3);
            }
            else{
                this.shellCilindInternalPressCalculator.designThickness = "Division 1 cannot be applied according to the UG - 27 (2)";
            }

            // WORKING MAXIMUM ALLOWABLE PRESSURE CORRODED AND HOT
            if(this.shellCilindInternalPressCalculator.validNominalThickness === false){
                this.shellCilindInternalPressCalculator.workingMaximumAllowablePressure = "INVALID NOMINAL THICKNESS";
            }
            else if(this.shellCilindInternalPressCalculator.nominalThickness === 0){
                this.shellCilindInternalPressCalculator.workingMaximumAllowablePressure = 0;
            }
            else if(this.shellCilindInternalPressCalculator.nominalThicknessMinusCorrosionAloowance < (0.5 * this.shellCilindInternalPressCalculator.insideRadiusCorroded)){
                this.shellCilindInternalPressCalculator.workingMaximumAllowablePressure = ((this.shellCilindInternalPressCalculator.admissibleStressDesignTemp * this.shellCilindInternalPressCalculator.weldedJointEfficiency * this.shellCilindInternalPressCalculator.nominalThicknessMinusCorrosionAloowance) / (this.shellCilindInternalPressCalculator.insideRadiusCorroded + 0.6 * this.shellCilindInternalPressCalculator.nominalThicknessMinusCorrosionAloowance)).toFixed(3);
            }
            else{
                this.shellCilindInternalPressCalculator.workingMaximumAllowablePressure = "Division 1 cannot be applied according to the UG - 27 (1)";
            }

            // HIDROSTATIC TEST PRESSURE
            if(this.shellCilindInternalPressCalculator.validNominalThickness === false){
                this.shellCilindInternalPressCalculator.hidrostaticTestPressure = "INVALID NOMINAL THICKNESS";
            }
            else{
                this.shellCilindInternalPressCalculator.hidrostaticTestPressure = (1.3 * this.shellCilindInternalPressCalculator.workingMaximumAllowablePressure * (this.shellCilindInternalPressCalculator.admissibleStressRoomTemp / this.shellCilindInternalPressCalculator.admissibleStressDesignTemp)).toFixed(3);
            }

            // PNEUMATIC TEST PRESSURE
            if(this.shellCilindInternalPressCalculator.validNominalThickness === false){
                this.shellCilindInternalPressCalculator.pneumaticTestPressure = "INVALID NOMINAL THICKNESS";
            }
            else{
                this.shellCilindInternalPressCalculator.pneumaticTestPressure = (1.1 * this.shellCilindInternalPressCalculator.workingMaximumAllowablePressure * (this.shellCilindInternalPressCalculator.admissibleStressRoomTemp / this.shellCilindInternalPressCalculator.admissibleStressDesignTemp)).toFixed(3);
            }

        },
        converterParaFloat(valor) {
            if (valor === "" || valor === null || valor === undefined) {
                return 0;
            }

            const valorString = valor.toString().trim();
            const valorSemEspacos = valorString.replace(/\s+/g, "");
            let valorNormalizado = valorSemEspacos;

            if (valorSemEspacos.includes(",") && valorSemEspacos.includes(".")) {
                const ultimoPonto = valorSemEspacos.lastIndexOf(".");
                const ultimaVirgula = valorSemEspacos.lastIndexOf(",");
                const separadorDecimal = ultimaVirgula > ultimoPonto ? "," : ".";
                const separadorMilhar = separadorDecimal === "," ? "." : ",";

                valorNormalizado = valorSemEspacos
                    .replace(new RegExp(`\\${separadorMilhar}`, "g"), "")
                    .replace(separadorDecimal, ".");
            } else if (valorSemEspacos.includes(",")) {
                valorNormalizado = valorSemEspacos.replace(/,/g, ".");
            }

            const valorConvertido = parseFloat(valorNormalizado);
            return isNaN(valorConvertido) ? 0 : valorConvertido;
        },
    },
};
</script>

<style>

/* TOOLTIP para informações adicionais */
.tooltip-custom {
  position: relative;
  display: inline-block;
  cursor: help;
}

.tooltip-custom .tooltip-text {
  visibility: hidden;
  width: 260px;
  background-color: #1f2937;
  color: #fff;
  text-align: left;
  border-radius: 8px;
  padding: 10px;
  position: absolute;
  z-index: 9999;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.tooltip-custom:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

/* BOTÕES */
.btn-secundario {
  background-color: #EDEFF2 !important;
  color: #3E4449 !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 10px 16px;
  border: none;
  white-space: nowrap;
  overflow: hidden;
  text-align: center !important;
}

.btn-secundario:hover {
  background-color: #e2e5e9 !important;
  color: #3E4449 !important;
}

/* IMAGEM FLUTUANDO */
.floating-drawing {
  position: fixed;
  width: 350px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.2);
  z-index: 9999;
  cursor: move;
  overflow: hidden;
  user-select: none;
}

.drawing-header {
  background: #0056FF;
  color: white;
  padding: 6px 10px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.material-options {
    overflow-x: hidden;
    max-height: 280px;
    overflow-y: auto;
    top: 100%;
    left: 0;
    z-index: 9999;
    border: 1px solid #d7e0ed;
    border-radius: 8px;
    box-shadow: 0 10px 24px rgba(23, 32, 51, 0.14);
}

.material-table {
    overflow: visible !important;
}

.material-option {
    cursor: pointer;
    color: #334e73;
    padding: 11px 14px;
    white-space: normal;
}

.material-option:hover,
.material-option:focus {
    background-color: #edf4ff;
    color: #0056ff;
}

.drawing-img {
  width: 100%;
  display: block;
}

.dragging {
  cursor: grabbing !important;
}

/* APENAS CELULAR */
@media (max-width: 575px) {
    .img-formulas{
        width: 250px;
    }
}

/* TABLET */
@media (min-width: 768px) and (max-width: 991px) {

    .img-formulas{
        width: 250px;
    }
}

</style>